module.exports = __webpack_public_path__ + "img/pf.bdd0b2c4.png";